module.exports = __webpack_public_path__ + "static/img/xsyzc-CLpAfVhZ.c43b8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/xsyzc-CLpAfVhZ.png
// module id = MUV7
// module chunks = 16